<template>
  <b-sidebar
    right
    shadow
    backdrop
    v-model="showSidebar"
    width="95%"
    @change="visibleChanged"
    prop
    no-header-close
    header-class="pd-0-f wd-100p core-edit-side-header"
  >
    <template v-slot:title>
      <nav class="navbar bd-b">
        <div class="dropdown" style="display:inherit">
          <a
            class="navbar-brand tx-bold tx-spacing--2 order-1"
            href="javascript:void(0)"
            data-toggle="dropdown"
            style="max-width: 500px; overflow: hidden; text-overflow: ellipsis"
          >
            <button class="btn btn-xs btn-outline-primary btn-uppercase mg-t-5">
              <feather type="menu" class="wd-20-f ht-20-f mg-r-5"></feather>цэс
            </button>
          </a>
          <div class="dropdown-menu tx-13">
            <a @click="showMention()" class="dropdown-item" role="button"
              >Хуваалцах</a
            >
          </div>
        </div>
        <span>{{ reportDetail.title }}</span>
        <button
          class="btn btn-sm pd-x-15 btn-uppercase mg-l-auto btn-danger"
          @click="visibleChanged(false)"
        >
          <feather type="x" class="mg-r-5"></feather>Хаах
        </button>
      </nav>
    </template>
    <!-- report here -->
    <div class="row no-gutters">
      <div class="col-xs-2 col-md-3">
        <div class="p-sm" style="position: relative">
          <loader
            @on-search="onSearch"
            v-if="ldr.isReady"
            :otCompName="ldr.otCompName"
            :propProjectId="ldr.projectId"
          />
        </div>
      </div>
      <div class="col-xs-10 col-md-9 bd-l">
        <iframe
          :src="reportDetail.link.full"
          :key="reportDetail.rptKey"
          class="rpt-frame"
        ></iframe>
      </div>
    </div>
    <mention-users
      :show="projectMention.show"
      :obj.sync="obj"
      :module="projectMention.module"
      @on-mention-close="projectMention.show = false"
    ></mention-users>
    <!-- <task-detail :id="id" @on-task-loaded="onLoaded" @on-attach="showAttach" @on-task-detail="taskDetail" @on-task-close="visibleChanged(false)" class="detail-on-sidebar"></task-detail> -->
  </b-sidebar>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import loader from "@/views/modules/report/search/loader";

export default {
  name: "ReportDetailOnDialog",
  components: {
    loader,
    mentionUsers: () => ({
      component: import("@/components/project/mention.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    id: {
      type: Number,
      default: () => 0,
    },
    obj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      reportBaseUrl: "https://report.gosmart.mn/",
      loading: true,
      reportDetail: {
        id: 0,
        title: "",
        rptName: "",
        link: {
          raw: "",
          full: "",
        },
        show: false,
        rptKey: 0,
      },
      ldr: {
        otCompName: "",
        projectId: 0,
        isReady: false,
      },
      showSidebar: false,
      projectMention: {
        module: "task",
        show: false,
      },
    };
  },
  mounted() {
    this.configure();
  },
  methods: {
    configure() {
      if (
        this.$store.state.app.activeGroup.reportBaseUrl != undefined &&
        this.$store.state.app.activeGroup.reportBaseUrl != ""
      ) {
        this.reportBaseUrl = this.$store.state.app.activeGroup.reportBaseUrl;
      }

      this.init();
    },
    showMention() {
      this.projectMention.module = "task";
      this.projectMention.show = true;
    },
    init() {
      this.reportDetail.id = this.obj.id;
      this.reportDetail.title = this.obj.task;
      this.reportDetail.rptName = this.obj.langCode;

      this.reportDetail.link.raw =
        this.reportBaseUrl +
        "home/reports?r=" +
        this.reportDetail.rptName +
        "&token=" +
        this.$store.state.user.token +
        "&org=" +
        this.$store.state.user.userInfo.groupName +
        "&user=" +
        this.$store.state.user.userInfo.fullName +
        "&pos=" +
        this.$store.state.user.userInfo.position;
      this.reportDetail.link.full = this.reportDetail.link.raw;
      this.reportDetail.rptKey++;
      this.$nextTick(function () {
        this.reportDetail.show = true;
      });

      if (this.obj.phone == null) {
        //console.log("from organizationTaskId");
        this.ldr.otCompName = this.obj.organizationTaskId;
      } else {
        //console.log("from phone");
        this.ldr.otCompName = this.obj.phone;
      }
      //console.log(t.organizationTaskId);
      this.ldr.isReady = true;
      this.showSidebar = true;
    },
    clearObj() {
      this.loading = true;
    },
    onLoaded(e) {
      this.taskObj.columns = e.columns;
      this.taskObj.task = e.task;
      this.taskObj.loaded = true;
      this.loading = false;
    },
    visibleChanged(e) {
      if (!e) {
        Object.assign(this.$data, this.$options.data());
        this.$emit("on-report-close");
      }
    },
    onSearch(e) {
      //console.log("onSearch", e);
      let params = "";
      Object.keys(e).forEach((x) => {
        if (Array.isArray(e[x])) {
          e[x].forEach((a) => {
            params += "&" + x + "=" + a;
          });
        } else {
          params += "&" + x + "=" + e[x];
        }
      });
      this.reportDetail.link.full = this.reportDetail.link.raw + params;
      //console.log(this.reportDetail.link.full);
      this.reportDetail.rptKey++;
    },
  },
};
</script>
<style>
.rpt-frame {
  border: none;
  width: 100%;
  height: calc(100vh - 75px);
}

iframe.rpt-frame .trv-content,
.rpt-frame .trv-nav {
  border: none !important;
}

.core-edit-side-header > strong {
  display: block;
  width: 100%;
}
</style>
